<template>
    <ContentOrLoading>
        <div class="form-group">
            <label for="moneda">Moneda</label>
            <ValidationProvider name="moneda" id="moneda" rules="required" v-slot="{ errors }">
                <multiselect
                    v-model="selected"
                    placeholder="Moneda"
                    label="title"
                    track-by="code"
                    :options="monedas"
                    :multiple="false"
                    v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
                ></multiselect>
                <span v-if="errors[0]" class="error invalid-feedback" style="display: block;">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </ContentOrLoading>    
</template>

<script>
    import ContentOrLoading from "../components/ContentOrLoading";

    export default {
        props: {
            moneda: {
                type: Number,
                default: 978
            }
        },
        data() {
            return {
                monedas: [],
                selected: {}
            }
        },
        mounted() {
            this.$store.dispatch(this.config.getVuexAlias('select.monedas')).then(res => {
                this.monedas = res.data.data;
                this.monedas.forEach(element => {
                    if(element.code == this.moneda) {
                        this.selected = element;
                    }
                });
            });
        },
        components: {
            ContentOrLoading
        }
    }
</script>
